export const ACTIVITY_HANDLER_URL = `${__TRACE_ADDIN_API_ORIGIN__}/ams/api/v1/ActivityHandler`;
